"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQuebecDocumentType = exports.GENERATE_POST_DOCUMENTS_RATE_LIMIT_DELAY = exports.GENERATE_POST_DOCUMENTS_TIMEOUT = exports.POST_DOCUMENT_TYPES = exports.DOCUMENT_TYPES = void 0;
exports.DOCUMENT_TYPES = {
    agr_1: 'agr_1',
    nr4: 'nr4',
    nr4_oas: 'nr4_oas',
    t101: 't101',
    t1135: 't1135',
    t1204: 't1204',
    t2202: 't2202',
    t3: 't3',
    t4: 't4',
    t4_2nd: 't4_2nd',
    t4a: 't4a',
    t4a_nr: 't4a_nr',
    t4a_oas: 't4a_oas',
    t4a_p: 't4a_p',
    t4a_rca: 't4a_rca',
    t4e: 't4e',
    t4ps: 't4ps',
    t4rif: 't4rif',
    t4rsp: 't4rsp',
    t5: 't5',
    t5007: 't5007',
    t5008: 't5008',
    t5008_r18: 't5008_r18',
    t5013: 't5013',
    t5018: 't5018',
    tp_1029: 'tp_1029',
    t2200: 't2200',
    tp64_3: 'tp64_3',
    rl_1: 'rl_1',
    rl_2: 'rl_2',
    rl_3: 'rl_3',
    rl_5: 'rl_5',
    rl_6: 'rl_6',
    rl_7: 'rl_7',
    rl_8: 'rl_8',
    rl_10: 'rl_10',
    rl_11: 'rl_11',
    rl_13: 'rl_13',
    rl_14: 'rl_14',
    rl_15: 'rl_15',
    rl_16: 'rl_16',
    rl_18: 'rl_18',
    rl_19: 'rl_19',
    rl_21: 'rl_21',
    rl_22: 'rl_22',
    rl_23: 'rl_23',
    rl_24: 'rl_24',
    rl_25: 'rl_25',
    rl_26: 'rl_26',
    rl_27: 'rl_27',
    rl_29: 'rl_29',
    rl_30: 'rl_30',
    rl_31: 'rl_31',
    rc210: 'rc210',
    rrspContributionReceipt: 'rrspContributionReceipt',
    rrspContributionReceiptFirst60days: 'rrspContributionReceiptFirst60days',
    fhsaContributionReceipt: 'fhsaContributionReceipt',
    childcareReceipt: 'childcareReceipt',
    childrenActivitiesReceipt: 'childrenActivitiesReceipt',
    studentLoanStatement: 'studentLoanStatement',
    federalNoticeOfAssessment: 'federalNoticeOfAssessment',
    provincialNoticeOfAssessment: 'provincialNoticeOfAssessment',
    associationContributionReceipt: 'associationContributionReceipt',
    selfEmployedInfoWithExpenses: 'selfEmployedInfoWithExpenses',
    selfEmployedInfoWithoutExpenses: 'selfEmployedInfoWithoutExpenses',
    selfEmployedFederalInstallment: 'selfEmployedFederalInstallment',
    selfEmployedProvincialInstallment: 'selfEmployedProvincialInstallment',
    rentalIncomeDetails: 'rentalIncomeDetails',
    preBankruptcyReturns: 'preBankruptcyReturns',
    foreignIncomeDetails: 'foreignIncomeDetails',
    other: 'other',
};
var POST_DOCUMENT_TYPES;
(function (POST_DOCUMENT_TYPES) {
    POST_DOCUMENT_TYPES["documentToApprove"] = "documentToApprove";
    POST_DOCUMENT_TYPES["documentToSign"] = "documentToSign";
})(POST_DOCUMENT_TYPES = exports.POST_DOCUMENT_TYPES || (exports.POST_DOCUMENT_TYPES = {}));
exports.GENERATE_POST_DOCUMENTS_TIMEOUT = 1000 * 60 * 2; // 2 minutes
exports.GENERATE_POST_DOCUMENTS_RATE_LIMIT_DELAY = 1000 * 60 * 5; // 5 minutes
function isQuebecDocumentType(documentType) {
    return (/^(rl_|tp[_\d])/.test(documentType) ||
        documentType === exports.DOCUMENT_TYPES.provincialNoticeOfAssessment);
}
exports.isQuebecDocumentType = isQuebecDocumentType;
//# sourceMappingURL=document.js.map